module.exports = __webpack_public_path__ + "static/media/checkmark.0e43eef9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/checkmark.svg
 ** module id = 454
 ** module chunks = 0
 **/